export default {"betWrapper":"ui63x","name":"gdS3-","spreadValue":"-j50e","subeventName":"-wzG7","marketName":"l54Rj","closeBet":"XDolj","disabled":"gFJ5T"};